/**
 * Actions have a type that where the name will show up in logs.
 */
export enum PrivacyActions {
  getLinkedInStatus = 'user/getLinkedInStatus',
  getLinkedInStatusResponse = 'user/getLinkedInStatus/success',
  getLinkedInStatusFailed = 'user/getLinkedInStatus/failed',

  revokeLinkedIn = 'user/revokeLinkedIn',
  revokeLinkedInResponse = 'user/revokeLinkedIn/success',
  revokeLinkedInFailed = 'user/revokeLinkedIn/failed',

  getTermsOfUse = 'user/getTermsOfUse',
  getTermsOfUseResponse = 'user/getTermsOfUse/success',
  getTermsOfUseFailed = 'user/getTermsOfUse/failed',
  getPrivacyStatement = 'organization/privacy-statement',

  getItemInsightsStatus = 'user/getItemInsightsStatus',
  enableItemInsights = 'user/enableItemInsights',
  disableItemInsights = 'user/disableItemInsights',

  getPeopleInsightsStatus = 'user/getPeopleInsightsStatus',
  enablePeopleInsights = 'user/enablePeopleInsights',
  disablePeopleInsights = 'user/disablePeopleInsights',

  getContactMergeSuggestionsStatus = 'user/getContactMergeSuggestionsStatus',
  enableContactMergeSuggestions = 'user/enableContactMergeSuggestions',
  disableContactMergeSuggestions = 'user/disableContactMergeSuggestions',

  getOrgContactInsightsStatus = 'organization/getContactInsights',

  downloadDiscoveredContacts = 'privacy/contact-controls/download-discovered',
  deleteDiscoveredContacts = 'privacy/contact-controls/delete-discovered',
  getContactDiscoveryStatus = 'privacy/contact-controls/get-discovery-status',
  toggleContactDiscovery = 'privacy/contact-controls/toggle-contact-discovery',
  downloadImportedContacts = 'privacy/contact-controls/download-imported',
  deleteImportedContacts = 'privacy/contact-controls/delete-imported',
}
